function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { event } from '@zillow/universal-analytics';
import { Button } from '@zillow/constellation';

var sendClickstreamEvent = function sendClickstreamEvent(priceTarget) {
  event({
    // https://dataportal.zillowgroup.net/event-registry/6456
    envelope: {
      event_type_id: '6456',
      event_type_version_id: '2',
      event_template_id: '422',
      event_template_version_id: '1'
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'cms',
      trigger_source_nm: 'cms_button',
      trigger_object_nm: 'no_trigger_object'
    },
    semantic: {
      semantic_event_nm: 'showcase_dts_interaction',
      topic_tag_txt: ['showcase', 'dts']
    },
    showcase_dts_info: {
      price_target: priceTarget
    }
  });
};
/**
 * Builds a DTS Contact url
 * Current url should have the format: https://zillow.com/c/showcase-{id}?zpid={zpid}
 * Result url should have the format: https://zillow.com/sell/options/showcase/contact?zpid={zpid}&target={targetId}
 * @returns
 */


var getRedirectUrl = function getRedirectUrl(origin, zpid, target) {
  return origin + "/sell/options/showcase/contact?zpid=" + zpid + "&target=" + target;
};

var ButtonRedirect = function ButtonRedirect(props) {
  var urlPath = props.urlPath,
      defaultLabel = props.defaultLabel,
      bottomPriceTargetId = props.bottomPriceTargetId,
      bottomPriceTargetLabel = props.bottomPriceTargetLabel,
      middlePriceTargetId = props.middlePriceTargetId,
      middlePriceTargetLabel = props.middlePriceTargetLabel,
      topPriceTargetId = props.topPriceTargetId,
      topPriceTargetLabel = props.topPriceTargetLabel;

  if (!urlPath) {
    return null;
  }

  var url = new URL(urlPath);
  var zpid = url.searchParams.get('zpid');
  var target = url.searchParams.get('target');

  if (!zpid || !target) {
    console.error('zpid and target parameters are required in the URL');
    return /*#__PURE__*/React.createElement(Button, _extends({}, props, {
      disabled: true
    }), "Not Available");
  }

  var getLabel = function getLabel() {
    if (defaultLabel) {
      return defaultLabel;
    }

    switch (target) {
      case bottomPriceTargetId:
        return bottomPriceTargetLabel;

      case middlePriceTargetId:
        return middlePriceTargetLabel;

      case topPriceTargetId:
        return topPriceTargetLabel;

      default:
        return null;
    }
  };

  var onClick = function onClick() {
    var redirectUrl = getRedirectUrl(url.origin, zpid, target);

    if (redirectUrl) {
      // TODO: Send Clickstream event once event https://dataportal.ana.zillow.net/event-registry/6457 is ready
      sendClickstreamEvent(target); // TODO: Open in same tab

      window.location.assign(redirectUrl);
    }
  };

  var label = getLabel();
  return /*#__PURE__*/React.createElement(Button, _extends({}, props, {
    onClick: onClick
  }), label);
};

export default ButtonRedirect;
//# sourceMappingURL=ButtonRedirect.js.map